import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';
import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-active-inactive-model-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent, FormsModule, MatDividerModule, MatTableModule],
  templateUrl: './active-inactive-model-dialog.component.html',
  styleUrl: './active-inactive-model-dialog.component.scss'
})
export class ActiveInactiveModelDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<ActiveInactiveModelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {
  
    
  }

  activeInactivateModel() {
    this.dialogData.is_active = !this.dialogData.is_active;
    this.dialogRef.close(this.dialogData);
  }

  cancelActiveInactivateModel() {
    // this.dialogData.is_active = this.dialogData.is_active;
    // this.dialogRef.close(this.dialogData);
    this.dialogRef.close();
  }
}
